"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _global = _interopRequireDefault(require("./global"));
var base = _interopRequireWildcard(require("./base"));
var _react = require("@chakra-ui/react");
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var components = _interopRequireWildcard(require("../components/styles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import merge from 'lodash/merge';

// use this to extend the base theme of chakra, this adds on top of what is defined in baseConfig
const extendedTheme = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  styles: {
    global: _global.default
  },
  remToPixels: (rem, baseSize = 16) => !rem ? 0 : `${baseSize * Number(rem.replace('rem', ''))}`
};

// use this to override base themes from Chakra
const baseConfig = {
  ..._theme.default,
  ...base,
  components
};
var _default = exports.default = (0, _react.extendTheme)(extendedTheme, baseConfig);